angular.module('app.filters').filter('metricPrefix', function($filter) {
    const numberWithUnitFilter = $filter('numberWithUnit');

    return function(number, extraText) {
        if (number == null) { return ''; }
        extraText || (extraText = '');

        // Reduce the number to be < 1000
        let tridecadic_reduction = 0;
        while (number >= 1000.0) {
            number /= 1000.0;
            tridecadic_reduction += 1;
        }

        const prefix = (() => {
            switch (tridecadic_reduction) {
                case 0:
                    return '';
                case 1:
                    return 'k';
                case 2:
                    return 'M';
                case 3:
                    return 'G';
                case 4:
                    return 'T';
                case 5:
                    return 'P';
                default:
                    return `10^${3 * tridecadic_reduction} `;
            }
        })();

        return numberWithUnitFilter(number, 1, prefix + extraText);
    };
});


// WEBPACK FOOTER //
// ./filters/metric_prefix.js